/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_New_GameInputs */

const bn_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নতুন খেলা`)
};

const de_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Spiel`)
};

const el_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Νέο παιχνίδι`)
};

const en_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New game`)
};

const es_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo juego`)
};

const fr_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle partie`)
};

const hi_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया खेल`)
};

const hu_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Új játék`)
};

const id_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan baru`)
};

const it_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo gioco`)
};

const ja_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいゲーム`)
};

const ko_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새로운 게임`)
};

const nl_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuw spel`)
};

const pl_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowa gra`)
};

const pt_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo jogo`)
};

const ru_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новая игра`)
};

const sv_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nytt spel`)
};

const tr_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni oyun`)
};

const uk_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нова гра`)
};

const vi_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trò chơi mới`)
};

const zh_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新游戏`)
};

const zh_hant_game_new_game = /** @type {(inputs: Game_New_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新遊戲`)
};

/**
* | output |
* | --- |
* | "New game" |
*
* @param {Game_New_GameInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_new_game = /** @type {((inputs?: Game_New_GameInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_New_GameInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_new_game(inputs)
	if (locale === "de") return de_game_new_game(inputs)
	if (locale === "el") return el_game_new_game(inputs)
	if (locale === "en") return en_game_new_game(inputs)
	if (locale === "es") return es_game_new_game(inputs)
	if (locale === "fr") return fr_game_new_game(inputs)
	if (locale === "hi") return hi_game_new_game(inputs)
	if (locale === "hu") return hu_game_new_game(inputs)
	if (locale === "id") return id_game_new_game(inputs)
	if (locale === "it") return it_game_new_game(inputs)
	if (locale === "ja") return ja_game_new_game(inputs)
	if (locale === "ko") return ko_game_new_game(inputs)
	if (locale === "nl") return nl_game_new_game(inputs)
	if (locale === "pl") return pl_game_new_game(inputs)
	if (locale === "pt") return pt_game_new_game(inputs)
	if (locale === "ru") return ru_game_new_game(inputs)
	if (locale === "sv") return sv_game_new_game(inputs)
	if (locale === "tr") return tr_game_new_game(inputs)
	if (locale === "uk") return uk_game_new_game(inputs)
	if (locale === "vi") return vi_game_new_game(inputs)
	if (locale === "zh") return zh_game_new_game(inputs)
	return zh_hant_game_new_game(inputs)
});